import axios from '../api';
import store from './../store';
import router from '../router';
import constants from '../constants';

export default {
  namespaced: true,

  state: {
    authenticated: false,
    user: null,
    role: '',
    permissions: [],
    permissionsOnBeneficiariesNeopass:[],
    subscription:{},
    isFirstLogin: false,
    timerExpirationSession: 0,
    structure:null,
    isGuest: false,
  },

  getters: {
    authenticated(state) {
      return state.authenticated;
    },

    user(state) {
      return state.user;
    },

    role(state){
      return state.role;
    },

    permissions(state){
      return state.permissions;
    },

    permissionsOnBeneficiariesNeopass(state){
      return state.permissionsOnBeneficiariesNeopass;
    },

    subscription(state){
      return state.subscription;
    },

    isFirstLogin(state){
      return state.isFirstLogin;
    },

    timerExpirationSession(state){
      return state.timerExpirationSession;
    },

    structure(state){
      return state.structure;
    }, 

    isGuest(state){
      return state.isGuest;
    }
  },

  mutations: {
    SET_AUTHENTICATED(state, value) {
      state.authenticated = value;
    },

    SET_USER(state, value) {
      state.user = value;
    },

    SET_ROLE(state, role){
      state.role = role;
    },

    SET_PERMISSIONS(state, perms){
      state.permissions = perms;
    },

    SET_PERMISSIONSONBENEFICIARIESNEOPASS(state, perms){
      state.permissionsOnBeneficiariesNeopass = perms;
    },

    SET_SUBSCRIPTION(state, sub){
      state.subscription = sub;
    },

    SET_ISFIRSTLOGIN(state, bool){
      state.isFirstLogin = bool;
    },

    SET_TIMEREXPIRATIONSESSION(state, timer){
      state.timerExpirationSession = timer;
    },

    SET_STRUCTURE(state, struct){
      state.structure = struct;
    }, 

    SET_ISGUEST(state, bool){
      state.isGuest = bool;
    }
  },

  actions: {
    async login({ commit, dispatch }, credentials) {
      await axios.get('/sanctum/csrf-cookie');
      await dispatch('logout'); //logout before login to avoir double auth (invite & company)
            
      await axios.post('/login', credentials).then((response) => {
        if(response.data === 'first_login'){
          commit('SET_ISFIRSTLOGIN', true);
        }
      }).catch((error) => {
        console.log(error.response);
        if(error.response.status === 422){ //Case request validation error 422
          console.log('422', Object.values(error.response.data.errors)[0]);
          throw new Error(Object.values(error.response.data.errors)[0]);  
        }
        throw new Error(error.response.data);
      });
      return dispatch('me');
    },

    async loginGuest({ dispatch }, credentials) {
      await axios.get('/sanctum/csrf-cookie');
      await dispatch('logout'); //logout before login to avoir double auth (invite & company)

      await axios.post('/guest/login', credentials).then(() => {

      }).catch((error) => {
        throw {...error};
      });
            
      return dispatch('me');
    },

    async register({ dispatch }, credentials) {
      await axios.post('/register', credentials).then(response => {
        if(response.status === 200){
          alert('Votre compte a bien été créé.\n Vous allez recevoir un e-mail pour confirmer votre adresse.\n Pensez à vérifier votre dossier spam.');
        }
      });
      return dispatch('me');
    },

    async request_reset_password(context, credentials) {
      await axios.post('/password/email', credentials);
    },

    async reset_password({ dispatch }, credentials) {
      await axios.post('/password/reset', credentials);
      return dispatch('me');
    },

    async create_referent_password({ dispatch }, credentials) {
      await axios.post('/createReferentPassword', credentials);
      return dispatch('me');
    },

    async reloadSessionTime(){
      return await axios.get('/session/resetTimer');
    },

    async loadStructureSession(){
      return await axios.get('api/sessionStructure').then(response => {
        return response.data;
      });
    },
        
    async changeStructure(context, idStructure){
      store.commit('app/SET_LOADING', true);
      await axios.get('/api/structure/edit/'+idStructure).then(response => {
        context.commit('SET_STRUCTURE', {...response.data, value:response.data.name});
        store.commit('app/SET_LOADING', false);
      }).catch(() =>{
        store.commit('app/SET_LOADING', false);
      });
    },

    async logout({ getters, dispatch }) {
      if(getters.isGuest){
        await axios.post('/guest/logout');
      }
      if(!getters.isGuest){
        await axios.post('/logout');
      }
      return dispatch('me');
    },

    async me({ getters, commit, dispatch }) {
      console.log('waiting authentication...');
            
      const { data: guard } = await axios.get('/api/guard');

      if(guard === 'invitation'){
        return axios
          .get('/api/invitation')
          .then(async response => {
                    
            let datas = response.data;
            commit('SET_ISGUEST', true);
            commit('SET_USER', datas.invitation);

            commit('SET_AUTHENTICATED', true);        
            commit('SET_ROLE', constants.ROLE_INVITE);  
            commit('SET_PERMISSIONS', [constants.PERMISSION_NEOPASS_FORM_PAGE, ...getters.user.permissions.map(p => p.name)]);

            let beneficiaryPermissions = {};
            beneficiaryPermissions[datas.invitation.user_id] = getters.user.permissions.map(p => p.name);

            commit('SET_PERMISSIONSONBENEFICIARIESNEOPASS', beneficiaryPermissions);
            commit('SET_SUBSCRIPTION', {name:'Neopass', quantity: 1});
                    
          }).catch((error) => {
            console.log('error');
            console.log(error.response.status);
          });
      }

      if(guard === 'user'){
        return axios.get('/api/user').then(async response => {
          commit('SET_AUTHENTICATED', true);
                    
          if(response.data.deleted_at != null){
            commit('SET_AUTHENTICATED', false);
            return;
          }
                    
          commit('SET_USER', response.data);

          // Define structure according to session variable
          if(!getters.user.is_particulier){
            await dispatch('loadStructureSession').then(async response => {
              let idStructure = (response) ? response.id : getters.user.companies[0].id;
              await dispatch('changeStructure', idStructure);
            });
          }         

          const { data: permissions } = await axios.get('/api/permissions/names');
          const { data: roles } = await axios.get('/api/role/name');

          commit('SET_ROLE', roles);

          this._vm.$laravel.setRoles(roles);
          this._vm.$laravel.setPermissions(permissions);

          commit('SET_PERMISSIONS', this._vm.$laravel.getPermissions());

          const { data: permissionsOnBeneficiariesNeopass } = await axios.get('/api/user-rights');
          commit('SET_PERMISSIONSONBENEFICIARIESNEOPASS', permissionsOnBeneficiariesNeopass);

          if(!getters.user.is_particulier)
          {
            await axios.get('/api/subscription/subscription').then((response) => {
              if(response.data != 'SuperAdmin' && response.data.length > 0){
                commit('SET_SUBSCRIPTION', response.data[0]);
              }
              else if(response.data === 'SuperAdmin'){
                commit('SET_SUBSCRIPTION', {name:'Neopass', quantity: 1}); //to specify a fake subscription
              }
              else{
                commit('SET_SUBSCRIPTION', []);
              }
            });
          }
        })
          .catch((error) => {
            console.log('auth.js, me()', error);
            commit('SET_AUTHENTICATED', false);
            commit('SET_USER', null);
          });
      }
    },
  }
};
